const BIRTH = {
    name: 'Liste de naissance',
    description: `La liste de naissance de mon enfant.<br/>
      Partagée avec la famille afin que chacun puisse réserver et participer.`,
    technologies: ['HTML', 'CSS', 'React', 'Redux', 'MaterialUI', 'Firestore', 'Firebase Storage'],
    firstReleaseDate: '19/01/2020'
};

export default BIRTH;
